export class curriculumCollectionManagement {
  constructor(form) {
    if (form) {
      this.id = form.id;
      this.title = form.title;
      this.subTitle = form.subTitle;
      this.introduction = form.introduction;
      this.classImage = {
        headImg: form.headImg,
        shareCardImg: form.shareCardImg,
        shareImg: form.shareImg,
      };
      this.courses = form.courses;
      this.videoIntroduction = form.videoIntroduction;
      this.mediaLink = form.mediaLink;
    } else {
      this.clear();
    }
  }

  clear() {
    this.id = null;
    this.title = '';
    this.subTitle = '';
    this.introduction = '';
    this.classImage = {
      headImg: '',
      shareCardImg: '',
      shareImg: '',
    },
    this.courses = [];
    this.videoIntroduction = '';
    this.mediaLink = '';
  }
}
